import * as atlas from 'azure-maps-control';
import { Coordinates } from '../../../../types/common/address';

export abstract class Marker {
  constructor(readonly coordinates?: Coordinates) {
    this.coordinates = coordinates;
  }

  abstract get id(): string;
  get properties() {
    return {
      id: this.id,
    };
  }

  createMapFeature() {
    if (!this.coordinates) return null;
    return new atlas.data.Feature(
      new atlas.data.Point([this.coordinates.longitude, this.coordinates.latitude]),
      {
        ...this.properties,
      },
      this.id,
    );
  }
}
